declare global {
  interface RouterMeta {
    title: string;
  }
  interface Router {
    path: string;
    name: string;
    icon?: string;
    permission?: string;
    meta?: RouterMeta;
    component: any;
    children?: Array<Router>;
  }
  interface System {
    import(request: string): Promise<any>;
  }
  var System: System;
}
import login from '../views/login.vue';
import main from '../views/main.vue';
import ads from '../views/pages/ads.vue';
import occupations from '../views/pages/occupations.vue';
import users from '../views/pages/users.vue';
import contentManagement from '../views/pages/contentManagement.vue';
import adUsers from '../views/pages/adUsers.vue';
import generalSettings from '../views/pages/generalSettings.vue';

export const loginRouter: Router = {
  path: '/',
  name: 'login',
  meta: {
    title: 'LogIn',
  },
  component: () => import('../views/login.vue'),
};

export const otherRouters: Router = {
  path: '/main',
  name: 'main',
  permission: '',
  meta: { title: 'ManageMenu' },
  component: main,
  children: [
    {
      path: 'home',
      meta: { title: 'HomePage' },
      name: 'home',
      component: () => import('../views/pages/home.vue'),
    },
  ],
};



export const appRouters: Array<Router> = [
  {
    path: '/pages',
    name: 'page',
    permission: '',
    meta: { title: 'ManageMenu' },
    icon: '&#xe68a;',
    component: main,
    children: [
      {
        path: 'ads',
        meta: { title: 'Ads' },
        name: 'ads',
        component: () =>
          import('../views/pages/ads.vue'),
      },

      {
        path: 'occupations',
        meta: { title: 'Occupations' },
        name: 'occupations',
        component: () =>
          import('../views/pages/occupations.vue'),
      },

      {
        path: 'users',
        meta: { title: 'Users' },
        name: 'users',
        component: () =>
          import('../views/pages/users.vue'),
      },

      {
        path: 'contentManagement',
        meta: { title: 'Content Management' },
        name: 'contentManagement',
        component: () =>
          import('../views/pages/contentManagement.vue'),
      },

      {
        path: 'adUsers',
        meta: { title: 'Ad Users' },
        name: 'adUsers',
        component: () =>
          import('../views/pages/adUsers.vue'),
      },

      {
        path: 'generalSettings',
        meta: { title: 'General Setttings' },
        name: 'generalSettings',
        component: () =>
          import('../views/pages/generalSettings.vue'),
      },

    ],
  },




];

export const routers = [loginRouter, ...appRouters, otherRouters];
